import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { debounceTime, Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[luiResizeObserver]',
    standalone: false
})
export class ResizeObserverDirective implements OnInit, OnDestroy {
  @Output() resized = new EventEmitter<ResizeObserverEntry>();
  @Input() debounceTime = 0;

  private _destroy$ = new Subject<void>();

  resizeSubject = new Subject<ResizeObserverEntry>();

  observer!: ResizeObserver;
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        this.resizeSubject.next(entry);
      });
    });

    this.resizeSubject
      .pipe(takeUntil(this._destroy$), debounceTime(this.debounceTime))
      .subscribe((resizeObserverEntry) =>
        this.resized.emit(resizeObserverEntry)
      );

    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.unobserve(this.elementRef.nativeElement);
    this._destroy$.complete();
  }
}
